export const getApiUrl = () => process.env.REACT_APP_API_URL;
export const getAuthUrl = () => process.env.REACT_APP_AUTH_URL;
export const getTerminal = () => process.env.REACT_APP_TERMINAL_ID;
